<template>
    <div class="login-container">
        <div class="login-panel">
            <img src="../../assets/images/navitas_logo_white.png" alt="Navitas Safetey Group">
            <text-input autocomplete="username email" name="email" style="margin-bottom: 70px" label="E-mail" ref="username" @keyup.enter.native="actionLogin"/>

            <text-button label="Sign in using sso" :loading-state="loadingState" @click="actionLogin"/>

            <div class="login-link">
                <a @click="actionReturnToLogin">Return to standard login</a>
            </div>
        </div>
        <login-notice />
    </div>
</template>
<script>
import TextInput from "../components/TextInput";
import TextButton from "../components/TextButton";
import {mapMutations} from "vuex";
import AuthService from "../../new/services/AuthService";
import LoginNotice from "../components/LoginNotice";

export default {

    name: "FederatedEmailLogin",
    components: {LoginNotice, TextButton, TextInput},
    data() {
        return {
            loadingState: false,
        }
    },
    methods: {

        actionLogin() {
            
            this.loadingState = true;
            
            this.$api.federatedEmailLogin({
                data: {
                    username: this.$refs.username.value,
                }
            }).then(({data}) => {
                window.location.href = data.redirectURL;
            }).finally(() => {
                this.loadingState = false;
            });

        },
        actionReturnToLogin() {
            this.$router.push(this.$enums.RoutePathEnum.LOGIN);
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
        })
    },
    mounted() {
        if (AuthService.isLogged()) {
            this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
        }
        this.setGlobalLoadingState(false);
    }
}
</script>
